module.exports = __webpack_public_path__ + "static/media/Hum.88d30627.wav";